import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["input", "panel", "list"]
  static values = { url: String, min: { type: Number, default: 2 }, delay: { type: Number, default: 150 } }

  connect() {
    this._timer = null
    this.hide()
    this._bindWindowClick = (e) => this.maybeHide(e)
    window.addEventListener("click", this._bindWindowClick)
  }

  disconnect() {
    this._clearTimer()
    window.removeEventListener("click", this._bindWindowClick)
  }

  inputChanged() {
    const q = this.inputTarget.value.trim()
    if (q.length < this.minValue) { this.hide(); return }

    this._clearTimer()
    this._timer = setTimeout(() => this.fetch(q), this.delayValue)
  }

  fetch(q) {
    const url = new URL(this._searchUrl(), window.location.origin)
    url.searchParams.set("q", q)

    fetch(url, { headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(json => this.render(json))
      .catch(() => this.hide())
  }

  render(items) {
    if (!Array.isArray(items) || items.length === 0) { this.hide(); return }

    this.listTarget.innerHTML = items.map(i => `
      <li class="list-group-item list-group-item-action d-flex flex-column py-2">
        <small class="text-muted text-uppercase">${this._escape(i.type)}</small>
        <a href="${this._escape(i.url)}" class="stretched-link fw-semibold">${this._escape(i.title)}</a>
        ${i.snippet ? `<span class="text-muted small">${this._escape(i.snippet)}</span>` : ""}
      </li>
    `).join("")

    this.show()
  }

  show() {
    this.panelTarget.classList.remove("d-none")
  }

  hide() {
    this.panelTarget.classList.add("d-none")
    this.listTarget.innerHTML = ""
  }

  clear() {
    this.inputTarget.value = ""
    this.hide()
  }

  keyDown(event) {
    if (event.key === "Escape") {
      this.hide()
      return
    }
  }

  _clearTimer() { if (this._timer) { clearTimeout(this._timer); this._timer = null } }

  _escape(s) {
    return (s || "").toString().replace(/[&<>"]/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]))
  }

  _searchUrl() {
    const raw = (this.hasUrlValue ? (this.urlValue || "") : "").toString().trim()
    if (raw) return raw
    // Fallback: build from current locale in <html lang> or path prefix
    const htmlLang = (document.documentElement.getAttribute("lang") || "").slice(0,2)
    const pathLocale = (window.location.pathname.split("/").filter(Boolean)[0] || "").slice(0,2)
    const locale = ["en","bg"].includes(htmlLang) ? htmlLang : (["en","bg"].includes(pathLocale) ? pathLocale : "en")
    return `/${locale}/search.json`
  }

  maybeHide(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }
}
